import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-institucional-layout',
  standalone: false,
  templateUrl: './institucional-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './institucional-layout.component.css'
})
export class InstitucionalLayoutComponent {
}
